import api from '../../../../api';
import { downloadFile } from '../../../../utils/downloadFile';
import { ResultsScore } from './results';

export type ExportData = Record<
  string,
  {
    exerciseId: string;
    exerciseType: 'medialink' | 'user-material';
    isAssignment: boolean;
    isZeroScore: boolean;
    amountOfItems: number;
    achievedAt: string | undefined;
    isLti: boolean | undefined;
    needsGrading: boolean | undefined;
    score: ResultsScore | undefined;
    session: string | undefined;
    duration: number | undefined;
  }[]
>;

export default async function getXlsxExport(moduleId: string, scoresPerMember: ExportData, lang: 'nl' | 'fr') {
  const response = await api.post(
    `/studio/modules/${moduleId}/exercise-scores/export`,
    {
      scoresPerMember,
      lang,
      sorting: 'alphabetic',
    },
    {
      responseType: 'arraybuffer',
      params: {
        studioGroup: process.env.REACT_APP_P_STUDIO_GROUP,
      },
    },
  );

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  return downloadFile(blob, 'export.xlsx');
}
